import { render, staticRenderFns } from "./LanguageSelecionButton.vue?vue&type=template&id=252f1dd3&scoped=true&lang=pug&"
import script from "./LanguageSelecionButton.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelecionButton.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelecionButton.vue?vue&type=style&index=0&id=252f1dd3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f1dd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu})
